import Vue from 'vue'
// import upperFirst from 'lodash/upperFirst'
// import camelCase from 'lodash/camelCase'

const requireComponent = require.context(".", false, /\.vue$/);
// console.log(requireComponent)
requireComponent.keys().forEach(fileName => {
    const componentConfig = requireComponent(fileName)
	// const componentName = upperFirst(camelCase(fileName.split('/').pop().replace(/\.\w+$/, '')))
	const componentName = fileName.split('/').pop().replace(/\.\w+$/, '')
	Vue.component(componentName,componentConfig.default || componentConfig)
});